<template>
    <v-dialog v-model="showModal" fullscreen :scrollable="isScrollable">
        <v-card light class="fill-height">
          <v-toolbar dark color="orange darken-3">
            <v-btn icon dark @click="close()">
              <v-icon large>mdi-arrow-left-circle</v-icon>
            </v-btn>
            <v-toolbar-title class="display-1">Check-in</v-toolbar-title>
          </v-toolbar>
            <v-stepper v-model="curr" color="green">
                <v-stepper-header>
                    <v-stepper-step
                        v-for="(step,n) in steps"
                        :key="n"
                        :complete="stepComplete(n+1)"
                        :step="n+1"
                        :color="stepStatus(n+1)">
                        {{ step.name }}
                    </v-stepper-step>
                </v-stepper-header>
                <v-stepper-content v-for="(step,n) in steps" :step="n+1" :key="n">
                    {{ step.name }}
                    <v-component v-if="step.valid" v-bind:is="step.component"
                      @stepSuccess="continueToNext(n)"
                    />
                </v-stepper-content>
            </v-stepper>
        </v-card>
    </v-dialog>
</template>

<script>
import Checkin from './Checkin.vue'
import UserCheck from '../ExistingUserCheck.vue'
import UserType from '../UserType.vue'
import Questions from './Questions.vue'
import FinalPage from '../FinalPage.vue'
import axios from '@/app-axios'
import constants from '@/constants'

export default {
  data: () => ({
    curr: 1,
    steps: [
      { name: '', component: UserCheck, valid: true, scrollable: true },
      { name: '', component: UserType, valid: false, scrollable: true },
      { name: 'Questions', component: Questions, valid: false, scrollable: false },
      { name: 'Confirm', component: Checkin, valid: false, scrollable: false },
      { name: '', component: FinalPage, valid: false, scrollable: false }
    ],
    valid: false,
    stepForm: [],
    showModal: true
  }),

  created () {
    this.getQuestions()
    this.$store.dispatch('decision/onProcessDecision', 'checkin')
  },

  computed: {
    isScrollable () {
      return this.steps[this.curr - 1].scrollable
    },
    lastStep () {
      return this.steps.length
    }
  },

  methods: {
    close () {
      this.showModal = false
      this.$router.push({ name: 'HomePage' })
    },
    stepComplete (step) {
      return this.curr > step
    },
    stepStatus (step) {
      return this.curr > step ? 'green' : 'orange darken-3'
    },
    continueToNext (n) {
      this.steps[n].valid = false
      this.steps[n + 1].valid = true
      this.curr += 1
    },
    done () {
      this.curr = this.lastStep
    },
    async getQuestions () {
      const config = {
        headers: {
          'x-organization-id': this.$store.getters['swiftuser/getOrganizationId'],
          'x-digi-board-id': this.$store.getters['swiftuser/getDigiBoardId']
        }
      }

      try {
        let response = await axios.get('api/swift-checkin/questions', config)
        this.$store.dispatch('questions/onAddQuestions', response.data)
      } catch (error) {
        this.$store.dispatch('alert/onAlert', {
          message: error.response.data.errors[0],
          type: constants.ALERT_TYPE_ERROR
        })
      }
    }
  }
}
</script>
